export default {
    realTimeDataText: {
      allShopText:'全店舗',//所有门店
      historyText:'履歴',//历史
      businessDataText:'営業データ',//营业数据
      memberDataText:'会員データ',//会员数据
      businessFlowText:'売上',//营业流水
      liushuiText:'売上',////流水金额
      vsLasWeekText:'先週比',//比上周
      vsYesterDayText:'昨日比.',//比昨天
      ssje:'実収額',//实收金额
      yhje:'割引額',//优惠金额
      yjds:'会計済件数',//已结单数
      wjje:'未会計額',//未结金额
      wjds:'未受注件数',//未结单数
      mgcz:'重要操作',//敏感操作
      sszt:'卓状況',//实时桌态
      ztzyl:'テーブル占有率',//桌台占用率
      rankingText:'順位',//排行
      djsq:'クリックで折りたたむ',//点击收起
      lookMoreText:'詳細を見る',//查看更多
      shopText:'店舗',//门店
      foodCategorizeText:'料理分類',//菜品分类
      foodName:'料理',//菜品
      numText:'件数',//单数
      salesNumText:'販売数',//销量
      fzSalesNumText:'補助数',//辅助销量
      yygc:'営業構成',//营业构成
      orderTypeText:'注文種別',//订单类型
      tsText:'店内',//堂食
      wmText:'配達',//外卖
      ztText:'持帰',//自提
      channelTypeText:'経路種別',//渠道类型
      mtText:'美团',
      elmText:'餓了么',
      posText:'POS',
      miniText:'小程序',
      yyqs:'売上推移',//营业趋势
      nowText:'現在',//当前
      lastWeekText:'先週',//上周
      yesterDayText:'昨日',//昨天
      kl:'客数',//客流
      peopleText:'人',//人
      yuan:'元',//元
      xfzb:'消費指標',//消费指标
      klrs:'人数',//客流人数
      zqkj:'割前客単',//折前客均
      zhkj:'割後客単',//折后客均
      zqdj:'割前平均',//折前单均
      zhdj:'割後平均',//折后单均
      cpmgcz:'料理操作',//菜品敏感操作
      giveFoodText:'無料(C/A)',//赠菜(次数/金额)
      returnFoodText:'返品(C/A)',//退菜(次数/金额)
      changePriceText:'価格変更(C/A)',//改价(次数/金额)
      discountText:'割引(C/A)',//打折(次数/金额)
      giveFoodText1:'無料',//赠菜
      returnFoodText1:'返品',//退菜
      changePriceText1:'価格変更',//改价
      discountText1:'割引',//打折
      zdmgcz:'会計操作',//账单敏感操作
      tds:'取消数',//退单数
      xgzdcs:'修正数',//修改账单次数
      searchText:'店舗名で検索する',
      nosearchdataText:'検索データはありません',
      orderNoText:"請求番号",//账单号
      dishNameText:"料理名 / 仕様",//菜品名称/规格
      quantityText:"数量",//数量
      amountText:"金額",//金额
      timeText:"時間",//时间
      personnelText:"担当者",//人员
      reasonText:"理由",//原因
      allloadedText:"全て読み込み完了",//已全部加载完
      loadingText:"読み込み中",//加载中...
      noDataText:"データがありません",//暂无数据
      zdlbText:"請求書一覧",//账单列表
      djzText:"精算待ち",//待结账
      yjzText:"精算済み",//已结账
      tableText1:"テーブル ",//桌台
      numText1:"就餐人数",//就餐人数
      billAmountText:"請求金額",//账单金额
      billDetailsText:"請求明細",//账单详情
      subtotalText:"小計",//小计
      totalText:"合計",//总计
      actualPaymentText:"実収科目",//实收科目
      discountItemsText:"割引科目",//优惠科目
      checkoutTimeText:"精算時間",//结账时间
      orderTimeText:"注文時間",//下单时间

    },
    historyDataText:{
      sjglText:'データ概要',//数据概览
        dayText:'日',//日
        weekText:'週',//周
        monthText:'月',//月'
        quarterText:'四半期',//季
        yearText:'年',//年'
        customText:'カスタム',//自定义
        selectDateText:'日付選択',//选择日期
        dateText:'日付',//日期
        confirmText:'確定',//确定
        salesFlowText:'売上',//流水
        actualReceivedText:'実収',//实收
        yhjezbText:'割引額/比率',//优惠金额/占比
        zdsText:'伝票数',//账单数
        klsText:'客数',//客流数
        zdgcText:'伝票構成',//账单构成
        channelText:'経路',//渠道
        keleiText:'客層',//客类
        payTypeText:'支払科目',//支付科目
        tableText:'卓統計',//桌台统计
        kaitaiText:'開卓率',//开台率
        fantaiText:'回転率',//翻台率
        shangzuoText:'着席率',//上座率
        mondayText:'月曜日',//周一
        tuesdayText:'火曜日',//周二
        wednesdayText:'水曜日',//周三
        thursdayText:'木曜日',//周四
        fridayText:'金曜日',//周五
        saturdayText:'土曜日',//周六
        sundayText:'日曜日',//周日
        startText:'始める',//开始
        endText:'終わる',//结束
        realTimeText:'リアルタイム'//实时
      },
      memberDataInfoText:{
        memberTotalText:"会員数／カード数",//会员总量/卡总量
        addMemberText:"新規会員",//新增会员
        addMemberCardText:"新規会員カード",//新增会员卡
        hyxfjeText:"会員消費額",//会员消费金额
        xfxjkzText:"現金カード消費",//消费现金卡值
        xfzskzText:"ギフトカード消費",//消费赠送卡值
        hyczjeText:"会員預金",//会员储值金额
        czxjkzText:"現金預金",//储值现金卡值
        czzskzText:"ギフト預金",//储值赠送卡值
        memberOrderNumText:"会員注文数",//会员订单数量
        hyldlsText:"会員による売上",//会员拉动流水
        hyldssText:"会員実収",//会员拉动实收
        huanbiText:'月次比較',//环比
        tongbiText:'年次比較',//同比
       }
  }
  